const states = [
  { abbr: 'All', name: 'All', url: '' },
  {
    abbr: 'AL',
    name: 'Alabama',
    url: 'https://alabama.findyourunclaimedproperty.com/',
  },
  {
    abbr: 'AK',
    name: 'Alaska',
    url: 'http://treasury.dor.alaska.gov//UnclaimedProperty.aspx',
  },
  { abbr: 'AZ', name: 'Arizona', url: 'https://azdor.gov/unclaimed-property/' },
  { abbr: 'AR', name: 'Arkansas', url: 'http://www.state.ar.us/auditor' },
  { abbr: 'CA', name: 'California', url: 'http://www.sco.ca.gov/upd_msg.html' },
  {
    abbr: 'CO',
    name: 'Colorado',
    url: 'https://colorado.findyourunclaimedproperty.com/',
  },
  { abbr: 'CT', name: 'Connecticut', url: 'https://ctbiglist.com/' },
  {
    abbr: 'DE',
    name: 'Delaware',
    url: 'https://unclaimedproperty.delaware.gov/app/claim-search',
  },
  {
    abbr: 'DC',
    name: 'District Columbia',
    url: 'https://cfo.dc.gov/page/unclaimed-property-how-reclaim-property',
  },
  {
    abbr: 'FL',
    name: 'Florida',
    url: 'http://www.fltreasurehunt.org/index.jsp',
  },
  {
    abbr: 'GA',
    name: 'Georgia',
    url: 'https://gaclaims.unclaimedproperty.com/en/Property/SearchIndex',
  },
  {
    abbr: 'HI',
    name: 'Hawaii',
    url: 'https://unclaimedproperty.ehawaii.gov/lilo/property-search.html',
  },
  { abbr: 'ID', name: 'Idaho', url: 'https://yourmoney.idaho.gov/' },
  { abbr: 'IL', name: 'Illinois', url: 'https://icash.illinoistreasurer.gov/' },
  { abbr: 'IN', name: 'Indiana', url: 'http://www.indianaunclaimed.gov/' },
  {
    abbr: 'IA',
    name: 'Iowa',
    url: 'http://www.treasurer.state.ia.us/for_citizens/great_iowa_treasure_hunt/',
  },
  { abbr: 'KS', name: 'Kansas', url: 'https://www.kansascash.com' },
  {
    abbr: 'KY',
    name: 'Kentucky',
    url: 'https://kyclaims.unclaimedproperty.com/',
  },
  {
    abbr: 'LA',
    name: 'Louisiana',
    url: 'https://www.treasury.la.gov/unclaimed-property-1',
  },
  { abbr: 'ME', name: 'Maine', url: 'https://www.maineunclaimedproperty.gov/' },
  {
    abbr: 'MD',
    name: 'Maryland',
    url: 'http://comptroller.marylandtaxes.com/Public_Services/Unclaimed_Property/',
  },
  {
    abbr: 'MA',
    name: 'Massachusetts',
    url: 'http://www.mass.gov/treasury/unclaimed-prop/',
  },
  {
    abbr: 'MI',
    name: 'Michigan',
    url: 'https://unclaimedproperty.michigan.gov/',
  },
  {
    abbr: 'MN',
    name: 'Minnesota',
    url: 'https://minnesota.findyourunclaimedproperty.com/',
  },
  {
    abbr: 'MS',
    name: 'Mississippi',
    url: 'https://treasury.ms.gov/for-citizens/unclaimed-property/',
  },
  { abbr: 'MO', name: 'Missouri', url: 'http://www.showmemoney.com' },
  {
    abbr: 'MT',
    name: 'Montana',
    url: 'http://revenue.mt.gov/home/businesses/unclaimed_property.aspx',
  },
  { abbr: 'NE', name: 'Nebraska', url: 'https://treasurer.nebraska.gov/up/' },
  {
    abbr: 'NV',
    name: 'Nevada',
    url: 'http://www.nevadatreasurer.gov/Unclaimed_Property/UP_Home/',
  },
  {
    abbr: 'NB',
    name: 'New Brunswick',
    url: 'http://www.fcnb.ca/FinancialConsumer.html',
  },
  { abbr: 'NH', name: 'New Hampshire', url: 'https://www.findnhmoney.gov/' },
  {
    abbr: 'NJ',
    name: 'New Jersey',
    url: 'http://www.unclaimedproperty.nj.gov/',
  },
  {
    abbr: 'NM',
    name: 'New Mexico',
    url: 'https://www.tax.newmexico.gov/individuals/what-is-unclaimed-property/file-a-claim/',
  },
  {
    abbr: 'NY',
    name: 'New York',
    url: 'http://www.osc.state.ny.us/ouf/index.htm',
  },
  { abbr: 'NC', name: 'North Carolina', url: 'http://www.NCCash.com' },
  {
    abbr: 'ND',
    name: 'North Dakota',
    url: 'https://unclaimedproperty.nd.gov/app/claim-search',
  },
  { abbr: 'OH', name: 'Ohio', url: 'http://www.com.ohio.gov/unfd/' },
  { abbr: 'OK', name: 'Oklahoma', url: 'http://www.oktreasure.com/' },
  {
    abbr: 'OR',
    name: 'Oregon',
    url: 'https://unclaimed.oregon.gov/app/claim-search',
  },
  { abbr: 'PA', name: 'Pennsylvania', url: 'http://www.patreasury.gov/' },
  { abbr: 'PR', name: 'Puerto Rico', url: 'https://www.ocif.pr.gov/' },
  {
    abbr: 'QC',
    name: 'Quebec',
    url: 'https://www.revenuquebec.ca/en/unclaimed-property/searches/register-of-unclaimed-property/',
  },
  { abbr: 'RI', name: 'Rhode Island', url: 'https://treasury.ri.gov/' },
  {
    abbr: 'SC',
    name: 'South Carolina',
    url: 'http://www.treasurer.sc.gov/unclaimed-property/',
  },
  {
    abbr: 'SD',
    name: 'South Dakota',
    url: 'https://southdakota.findyourunclaimedproperty.com/',
  },
  {
    abbr: 'TN',
    name: 'Tennessee',
    url: 'https://treasury.tn.gov/Unclaimed-Property/Claim-Unclaimed-Property/Find-Your-Missing-Money',
  },
  { abbr: 'TX', name: 'Texas', url: 'https://www.claimittexas.gov/' },
  { abbr: 'VI', name: 'US Virgin Islands', url: 'http://ltg.gov.vi' },
  { abbr: 'UT', name: 'Utah', url: 'http://mycash.utah.gov/' },
  {
    abbr: 'VT',
    name: 'Vermont',
    url: 'http://www.vermonttreasurer.gov/content/unclaimed-property',
  },
  { abbr: 'VA', name: 'Virginia', url: 'https://vamoneysearch.org/' },
  { abbr: 'WA', name: 'Washington', url: 'https://ucp.dor.wa.gov/' },
  { abbr: 'WV', name: 'West Virginia', url: 'http://www.wvtreasury.com/' },
  {
    abbr: 'WI',
    name: 'Wisconsin',
    url: 'https://www.revenue.wi.gov/Pages/UnclaimedProperty/Home.aspx',
  },
  {
    abbr: 'WY',
    name: 'Wyoming',
    url: 'https://statetreasurer.wyo.gov/unclaimed-property/',
  },
];

const sortedStates = states.slice().sort((a, b) => {
  if (a.abbr === 'All') return -1;
  if (b.abbr === 'All') return 1;
  return a.abbr.localeCompare(b.abbr);
});

export function useUnclaimedMoneyStatesOptionsAbbr() {
  return sortedStates.map((state) => {
    return {
      value: state.abbr === 'All' ? '' : state.abbr,
      display: state.abbr,
      url: state.url,
    };
  });
}

export function getStateUrl(stateName: string) {
  return states.find((state) => state.abbr === stateName)?.url || '';
}
